import { useApi } from '../composables/useApi'
import { URLS } from '../constants/urls'

export default function atendimentoSequoiaService() {
	const api = useApi()

	async function getAtendimentos() {
		return await api.query(`${window.origin}${URLS.atendimento_sequoia}`)
	}

	async function getAtendimentosFundacao(idFundacoes) {
		return await api.query(
			`${window.origin}${URLS.atendimento_sequoia}?fundacao=${idFundacoes}`
		)
	}

	async function createAtendimentoSequoia(data) {
		return api.mutation(
			`${window.origin}${URLS.atendimento_sequoia}`,
			'post',
			data
		)
	}

	async function updateAtendimentoSequoia(data, id) {
		return api.mutation(
			`${window.origin}${URLS.atendimento_sequoia}?pk=${id}`,
			'put',
			data
		)
	}

	return {
		getAtendimentos,
		getAtendimentosFundacao,
		createAtendimentoSequoia,
		updateAtendimentoSequoia,
		...api,
	}
}
